import { partition } from "@welshman/lib";
import { defaultOptimizeSubscriptions, getDefaultNetContext as originalGetDefaultNetContext, } from "@welshman/net";
import { LOCAL_RELAY_URL, isEphemeralKind, isDVMKind, unionFilters } from "@welshman/util";
import { tracker, repository } from "./core.js";
import { makeRouter, getFilterSelections } from "./router.js";
import { signer } from "./session.js";
export const getDefaultNetContext = (overrides = {}) => ({
    ...originalGetDefaultNetContext(),
    signEvent: async (event) => signer.get()?.sign(event),
    onEvent: (url, event) => {
        if (isEphemeralKind(event.kind) || isDVMKind(event.kind))
            return;
        tracker.track(event.id, url);
        repository.publish(event);
    },
    isDeleted: (url, event) => repository.isDeleted(event),
    optimizeSubscriptions: (subs) => {
        const [withRelays, withoutRelays] = partition(sub => sub.request.relays.length > 0, subs);
        const filters = unionFilters(withoutRelays.flatMap(sub => sub.request.filters));
        const selections = defaultOptimizeSubscriptions(withRelays);
        selections.push({ relays: [LOCAL_RELAY_URL], filters });
        if (filters.length > 0) {
            for (const selection of getFilterSelections(filters)) {
                selections.push(selection);
            }
        }
        return selections;
    },
    ...overrides,
});
export const getDefaultAppContext = (overrides = {}) => ({
    router: makeRouter(),
    requestDelay: 50,
    authTimeout: 300,
    requestTimeout: 3000,
    ...overrides,
});
//# sourceMappingURL=context.js.map